export default "__VITE_ASSET__BkAsWRUq__"